var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('create-content-layout',{attrs:{"title":'ایجاد درس جدید',"submitFunction":_vm.CreateContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }